import pythonApiClient from './pythonBaseApi';

/**
 * Ingresos corporativos: clientes de facturación y facturas de venta (FastAPI).
 */
const ingresosCorporativoApi = {
  // --- Clientes facturación ---
  getClientesFacturacion: (soloActivos = true) =>
    pythonApiClient.get('/corporativo/clientes-facturacion', {
      params: { solo_activos: soloActivos },
    }),

  getClienteFacturacion: (id) =>
    pythonApiClient.get(`/corporativo/clientes-facturacion/${id}`),

  createClienteFacturacion: (data) =>
    pythonApiClient.post('/corporativo/clientes-facturacion', data),

  updateClienteFacturacion: (id, data) =>
    pythonApiClient.put(`/corporativo/clientes-facturacion/${id}`, data),

  deleteClienteFacturacion: (id) =>
    pythonApiClient.delete(`/corporativo/clientes-facturacion/${id}`),

  // --- Facturas de venta ---
  getFacturasVenta: (params = {}) =>
    pythonApiClient.get('/corporativo/facturas-venta', { params }),

  getFacturaVenta: (id) => pythonApiClient.get(`/corporativo/facturas-venta/${id}`),

  createFacturaVenta: (data) =>
    pythonApiClient.post('/corporativo/facturas-venta', data),

  updateFacturaVenta: (id, data) =>
    pythonApiClient.put(`/corporativo/facturas-venta/${id}`, data),

  deleteFacturaVenta: (id) =>
    pythonApiClient.delete(`/corporativo/facturas-venta/${id}`),
};

export default ingresosCorporativoApi;
